import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";

const OrderCancel = () => (
  <main className="pt-32 sm:pt-40 pb-24 px-4 min-h-screen text-center" data-testid="order-cancel-page">
    <Reveal>
      <p className="font-display font-extrabold uppercase text-outline text-6xl">Paiement annulé</p>
      <p className="mt-6 text-sm text-neutral-400 max-w-md mx-auto">
        Aucun montant n'a été débité. Votre panier est intact — vous pouvez reprendre quand vous voulez.
      </p>
      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
        <Link to="/checkout" data-testid="order-cancel-retry" className="bg-white text-ink font-mono text-xs uppercase tracking-[0.25em] px-10 py-4 hover:bg-gold transition-colors">
          Reprendre le paiement
        </Link>
        <Link to="/boutique" data-testid="order-cancel-shop" className="border border-lineActive text-white font-mono text-xs uppercase tracking-[0.25em] px-10 py-4 hover:border-white transition-colors">
          Continuer mes achats
        </Link>
      </div>
    </Reveal>
  </main>
);

export default OrderCancel;
